import Script from 'next/script'

export default function NewrelicScript({ newRelicScriptName }: { newRelicScriptName: string }) {
  return (
    <Script
      id="newRelicScript"
      src={`/scripts/${newRelicScriptName}.js`}
      strategy="beforeInteractive"
    />
  )
}
